/**
 * Text Input Renderer
 * Handles: text, email, number input types
 * Features: icon support, error states, required indicator
 */
import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import type { FieldRenderer } from '@/MyCode/core';

export const renderTextInput: FieldRenderer = ({
    field,
    value,
    hasError,
    handleChange,
    renderIcon,
    isRequired
}) => (
    <div className="space-y-2">
        <Label htmlFor={field.name}>
            {field.label}
            {isRequired && <span className="text-destructive ml-1">*</span>}
        </Label>
        <div className="flex items-center">
            {renderIcon(field.ui?.icon)}
            <Input
                id={field.name}
                type={field.type}
                placeholder={field.placeholder}
                value={value || ''}
                onChange={(e) => handleChange(field.name, e.target.value)}
                maxLength={field.maxLength}
                className={`flex-1 ${hasError ? 'border-destructive' : ''}`}
            />
        </div>
    </div>
);

export default renderTextInput;